import { VeiculoModel } from "@/models/cadastros/assistencia/veiculo/VeiculoModel";
import LocalidadeModel from "@/models/geolocalizacao/LocalidadeModel";
import { QuestionarioModel } from "@/models/cadastros/assistencia/QuestionarioModel";
import ServicoSubClienteModel  from '@/models/cadastros/assistencia/ServicoSubClienteModel';
import ClienteAdministrativoModel from "@/models/cadastros/assistencia/ClienteAdministrativoModel";

export class QuestionarioBateriaModel implements QuestionarioModel {
  idServico?: number;
  veiculoPertenceAoAssociado: boolean;
  veiculo: VeiculoModel;
  localizacao: LocalidadeModel;
  nomeContatoNoLocal?: string;
  telefoneContatoNoLocal?: string;
  servicoSubCliente?: ServicoSubClienteModel;
  veiculoEletrico?: boolean;
  amperagemVeiculo?: String;
  clienteAdministrativo?: ClienteAdministrativoModel;
  constructor(
    veiculoPertenceAoAssociado: boolean,
    veiculo: VeiculoModel,
    localizacao: LocalidadeModel,
    nomeContatoNoLocal?: string,
    telefoneContatoNoLocal?: string,
    servicoSubCliente?: ServicoSubClienteModel,
    veiculoEletrico?: boolean,
    amperagemVeiculo?: String,
    clienteAdministrativo?: ClienteAdministrativoModel,
  ) {
    (this.veiculoPertenceAoAssociado = veiculoPertenceAoAssociado),
      (this.veiculo = veiculo),
      (this.localizacao = localizacao),
      (this.nomeContatoNoLocal = nomeContatoNoLocal),
      (this.telefoneContatoNoLocal = telefoneContatoNoLocal),
      (this.servicoSubCliente = servicoSubCliente),
      (this.veiculoEletrico = veiculoEletrico),
      (this.amperagemVeiculo = amperagemVeiculo);
      (this.clienteAdministrativo = clienteAdministrativo);
  }
}
